/**
 * Page enum represents page types.
 */
export var CouponPage;
(function (CouponPage) {
    /**
     * World wide list page
     */
    CouponPage["WORLD_WIDE"] = "WORLD_WIDE";
    /**
     * Hotel list page
     */
    CouponPage["HOTEL_LIST"] = "HOTEL_LIST";
    /**
     * Hotel details page
     */
    CouponPage["HOTEL_DETAILS"] = "HOTEL_DETAILS";
    /**
     * The booking form page
     */
    CouponPage["BOOKING"] = "BOOKING";
})(CouponPage || (CouponPage = {}));
export default CouponPage;
